import { color as semanticsColor, useTheme } from '@veneer/theme';
// check if the color is a semantics color
function isSemanticsColor(color) {
  return Object.keys(semanticsColor.light).includes(color) && !['foreground', 'background', 'stroke'].includes(color);
}

// check if the color is inside color object (token or semantics)
function isColorObject(color, theme) {
  return Object.keys(theme.color).includes(color);
}

/**
 * Hook to receive a color (string, token, semantics) and check how to return default value.
 * @returns {string} color
 */
export default function useColor(color) {
  var theme = useTheme();
  if (isSemanticsColor(color)) {
    return theme.color[color].base.default;
  }
  if (isColorObject(color, theme)) {
    return theme.color[color];
  }
  return color;
}